
import { Component, Vue } from 'vue-property-decorator';

@Component({
  name: 'GridRowParagraph'
})
export default class LmsGridRowParagraph extends Vue {}
